import { Pipe, PipeTransform } from '@angular/core'; 

@Pipe({
    name: 'spaceUpperCase',
    standalone: false
})
export class spaceUpperCasePipe implements PipeTransform {

  transform(value: string) {
    if (value) { 
        value= value.replace(/([A-Z])/g, ' $1').trim()
    }
    return value;
}

}